import { optionsReducer } from "@/entities/options"
import { recommendationsReducer } from "@/widgets/ProductRecommendations/model"
import { combineReducers, configureStore } from "@reduxjs/toolkit"

// todo изменить импорт
import singleProductReducer from "@/pages/SingleProductPage/model/singleProductSlice"
import filterReducer from "@/features/Filter/model/filterSlice"

const rootReducer = combineReducers({
	options: optionsReducer,
	singleProduct: singleProductReducer,
	recommendations: recommendationsReducer,
	filter: filterReducer,
})

export const store = configureStore({
	reducer: rootReducer,
})

export default store
